<template>
  <div class="form-page">
<div class="module-header">
  <h3 class="module-name">Forms</h3>
</div>
    <div class="form flex">
      <div class="form-template-list">
        <div class="form-template-list__header">
          <div class=" s p-2 v-center space-between" style="padding-top: 10px; padding-bottom: 10px;">
            <h2 class="weight-500 l">Form Templates </h2>
          </div>
          <div class="input-group s">
            <input class="template-search" placeholder="Search Templates" v-model="searchKeyword"/>
          </div>
        </div>
      <div class="form-template-list__body">
        <RouterLink
          v-for="template in computedTemplateList"
          :key="template.id"
          :to="`/forms/template/${template.id}/list`"
          :class= "{'router-link-active' : template.id == templateId }"

        >
          <div class="form-template-item v-center"  :ref="`template-${template.id}`" v-if="Config.STANDARD_MATERIAL_FORM.form_type!==template?.form_type"     @click="templateClick(template)">
            <div class="form-template-item__name v-center s elipsis-text">
              <span>{{ template.name }} </span>
            </div>
          </div>
        </RouterLink>
      </div>
      </div>
      <div class="form-components flex-grow">
        <router-view></router-view>
      </div>
    </div>
  </div>
  </template>

<script>
import { getFormTemplates } from '@/api'
import Config from '@/config'
export default {
  name: 'FORM',
  data () {
    return {
      templateList: [],
      Config: Config,
      searchKeyword: '',
      templateId: this.$route.params.templateId
    }
  },
  computed: {
    computedTemplateList () {
      const computedTemplateListBasedOnKeyword = []
      for (let i = 0; i < this.templateList.length; i++) {
        if (this.templateList[i].name.toLowerCase().includes(this.searchKeyword.toLowerCase())) {
          computedTemplateListBasedOnKeyword.push(this.templateList[i])
        }
      }
      return computedTemplateListBasedOnKeyword
    }
  },
  watch: {
    '$store.state.projectIdForCollaborator' () {
      this.$router.replace('/forms')
      this.fetchFormTemplates()
    }
  },
  methods: {
    // clears the old data while moving to different templates
    templateClick (template) {
      this.templateId = template.id
      this.$store.commit('form/setFormFieldsTypeMap', {})
    },
    fetchFormTemplates () {
      getFormTemplates().then((res) => {
        this.templateList = res.core_form_templates
        if (this.templateId) {
          this.scrollToItem(this.templateId)
        }
        if (this.templateList.length > 0 && this.$route.path === '/forms') {
          this.$router.push(
            `/forms/template/${this.templateList[0].id}/list`
          )
        }
      })
    },
    scrollToItem (tempalateId) {
      this.$nextTick(() => {
        const itemEl = this.$refs[`template-${tempalateId}`]?.[0]
        if (itemEl) {
          itemEl.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          })
        }
      })
    }
  },
  created () {
    this.fetchFormTemplates()
  }
}
</script>

  <style lang="scss" scoped >
  .form-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }

  .form {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .form-components {
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .form-template-list {
    display: flex;
    flex-direction: column;
    min-height: 0;

    .template-search {
      height: 2.5em;
      background-color: white;
    }

    width: 20%;
    min-width: 250px; // Adjust as needed
    height: 100%;
    overflow: hidden;
    transition: width 0.7s ease-in-out, min-width 0.7s ease-in-out;
     background-color: var(--bg-color);
    // background-color: green;
    border-right: 1px solid var(--brand-color);
    position: relative;
    a {
      text-decoration: none;
      color: var(--text-color);
    }
    &__header {
      position: sticky;
      z-index: 1;
      top: 0;
      background-color: #f5e4b6;
      flex-shrink: 0;
    }

    &__body {
      overflow-y: auto;
      min-height: 0;
      flex: 1;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      }
    }
  }
  .form-template-item {
    background-color: var(--brand-color-3);
    color: black;
    margin: 6px 6px;
    padding-left: 6px;
    cursor: pointer;
    &__name {
      width: 100%;
      height: 30px;
    }
    .obsolete {
      border-color: var(--alert);
      color: var(--alert);
    }
  }
  .router-link-active {
    .form-template-item {
      background-color: var(--brand-color-2);
    }
  }
  @media screen and (max-width: 1366px) {
      .form-template-list {
          min-width: 200px;
          width: 15%;
      }
  }

  @media screen and (max-width: 1200px) {
      .form-template-list {
          min-width: 180px;
      }
  }

  @media screen and (max-width: 1024px) {
      .form-template-list {
          min-width: 150px;
      }
  }

  </style>
